import {
	createContext,
	ReactNode,
	useContext,
	useEffect,
	useState,
} from 'react'

type EnvConfig = (typeof import('../env-config'))['default'] | undefined

interface Props {
	readonly children: ReactNode
}

const EnvConfigContext = createContext<EnvConfig | undefined>(undefined)

const EnvConfigProvider = ({ children }: Props) => {
	const [envConfig, setEnvConfig] = useState<EnvConfig | undefined>()
	useEffect(() => {
		const loadEnvConfig = async () => {
			const module = await import('../env-config')
			setEnvConfig(module.default)
		}
		loadEnvConfig()
	}, [])

	return (
		<EnvConfigContext.Provider value={envConfig}>
			{children}
		</EnvConfigContext.Provider>
	)
}

export const useEnvConfig = () => useContext(EnvConfigContext)

export default EnvConfigProvider
